import request from '/@common/utils/request';
import { CancelToken } from 'axios';

//对话
export function dialogue(data: object) {
	return request({
		url: '/api/dialogue/dialogue',
		method: 'post',
		data,
	});
}
export function closeDialogueConn(clientId: number | string) {
	return request({
		url: '/api/dialogue/closeDialogueConn/' + clientId,
		method: 'get',
	});
}

// 获取相关参数
export function getDialogueParam(appId: number | string, appRoleId: string) {
	return request({
		url: `/api/conversation/getDialogueParam/${appId}/${appRoleId}`,
		method: 'get',
	});
}

//上传
export function uploadBatch(data?: object, id?: Number) {
	return request({
		url: '/api/dialogue/uploadBatch/' + id,
		method: 'post',
		data,
	});
}

//获取文件列表
export function listFile(params?: object) {
	return request({
		url: '/api/dialogue/listFile/' + params.conversationId,
		method: 'get',
	});
}
//删除文件
export function delFile(id?: Number) {
	return request({
		url: '/api/dialogue/delFile/' + id,
		method: 'delete',
	});
}
//获取所有对话
export function listDialogues(id: Number | String) {
	return request({
		url: '/api/conversation/listDialogues/' + id,
		method: 'get',
	});
}
// 新建对话
export function addConversation(data: object) {
	return request({
		url: '/api/conversation/add/',
		method: 'post',
		data,
	});
}
//获取应用列表
export function getAppList() {
	return request({
		url: '/api/app/v3/tree/category',
		method: 'get',
	});
}
//技能树分类下的技能
export function getcategoryByIdApi(data: object, cancelToken: CancelToken) {
	return request({
		url: '/api/app/v3/tree/apps',
		method: 'get',
		params: data,
		cancelToken
	});
}
// 获取会话列表
export function listConversations(data: object) {
	return request({
		url: '/api/conversation/listConversations',
		method: 'get',
		params: data,
	});
}
// 分页获取会话列表
export function listConversationsByPage(data: object) {
	return request({
		url: '/api/conversation/pageConversations',
		method: 'get',
		params: data,
	});
}

// 更新会话
export function updateConversation(data: object) {
	return request({
		url: '/api/conversation/update',
		method: 'put',
		data,
	});
}

export function updateCollectStatus(data: object) {
	return request({
		url: `/api/conversation/updateCollectStatus/${data.id}?isCollect=${data.isCollect}`,
		method: 'put',
	});
}
// 更新会话名称
export function updateNameConversation(id: string) {
	return request({
		url: `/api/conversation/updateName/${id}`,
		method: 'put',
	});
}

export function updateNameWithConversation(id: string) {
	return request({
		url: `/api/conversation/updateNameWithConversation/${id}`,
		method: 'put',
	});
}
// 删除会话
export function deleteConversation(id: Number | String) {
	return request({
		url: '/api/conversation/delete/' + id,
		method: 'delete',
	});
}

// 踩赞标签选项
export function feedbackListLabel(roleId: Number | String,id: Number | String) {
	return request({
		url: `/api/feedback/listLabel/${roleId}/${id}`,
		method: 'get',
	});
}

// 踩赞对话反馈
export function feedback(data: object) {
	return request({
		url: '/api/feedback/feedback',
		method: 'post',
		data,
	});
}

// 应用id策略
export function listRecommend() {
	return request({
		url: '/api/app/listRecommend',
		method: 'get',
	});
}
// 示例代码
export function dialogueCode(data: object) {
	return request({
		url: `/api/dialogue/code/JAVA`,
		method: 'post',
		data,
	});
}
//[首页技能] 推荐问题
export function listDialogueQuestion(dialogueId: Number | String) {
	return request({
		url: `/api/dialogue/listDialogueQuestion/` + dialogueId,
		method: 'get',
	});
}

export function listRecommendApps() {
	return request({
		url: `/api/app/v3/listRecommendApps`,
		method: 'get',
	});
}
//CV上传图片
export function uploadChatImg(data: object, cancelToken: CancelToken) {
	return request({
		url: '/api/dialogue/uploadChatImg',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		cancelToken
	});
}
//上传文件的预解析
export function prefill(data: object) {
	return request({
		url: '/api/dialogue/prefill',
		method: 'post',
		data
	});
}
//CV删除图片
export function delChatImg(id: string) {
	return request({
		url: '/api/dialogue/delChatImg/' + id,
		method: 'delete',
	});
}


/**
 * @description: 查询插件详细信息
 */
export function getPluginInfo(data: { code: string }) {
	return request({
		url: `/api/dialogue/getPluginsInfo`,
		method: 'get',
		params: data,
	});
}
// 获取技能
export function getPrompt(params: object, type: string) {
	return request({
		url: '/api/app/v3',
		method: type,
		params
	});
}
// 获取技能ai推荐
export function generateByAiV3(params: object) {
	return request({
		url: '/api/app/v3/generateByAi',
		method: 'get',
		params
	});
}
// 获取全部技能分类列表
export function listCategory() {
	return request({
		url: '/api/category/allList',
		method: 'get',
	});
}
// 统计技能的点击次数
export function clicksCount(id: string) {
	return request({
		url: `/api/app/v3/clicksCount?appId=${id}`,
		method: 'get',
	});
}
//新增技能
export function addPrompt(data: object) {
	return request({
		url: '/api/app/v3',
		method: 'post',
		data
	});
}
//编辑技能
export function editPrompt(data: object) {
	return request({
		url: '/api/app/v3',
		method: 'put',
		data
	});
}
// 获取温度
export function getTemperature() {
	return request({
		url: '/api/app/v3/temperature',
		method: 'get',
	});
}
// 执行技能
export function runPrompt(data: object) {
	return request({
		url: '/api/app/v3/execute',
		method: 'post',
		data
	});
}

/**
 * @description: 获取动态切换的关键字
 */
export function getSwitchKeyword() {
	return request({
		url: '/api/app/v3/recommendWord',
		method: 'get',
	});
}
/**
 * @description: 获取模型调用次数
 */
export function getModelInvokeCount(modelVersion: string) {
	return request({
		url: `/api/dialogue/getModelInvokeCount/${modelVersion}`,
		method: 'get',
	});
}

// 获取角色列表
export function roleList(params: object) {
	return request({
		url: '/api/appRole/list',
		method: 'get',
		params
	});
}
// 删除角色列表
export function deleteRoles(id: string) {
	return request({
		url: `/api/appRole/delete/${id}`,
		method: 'delete'
	});
}
// 查询角色详情
export function getDetails(id: string) {
	return request({
		url: `/api/appRole/getDetails/${id}`,
		method: 'get'
	});
}
// 新增角色
export function addRoles(data: object) {
	return request({
		url: `/api/appRole/add`,
		method: 'post',
		data
	});
}
// 编辑角色
export function updateRoles(data: object) {
	return request({
		url: `/api/appRole/update`,
		method: 'post',
		data
	});
}
// ai推荐
export function generateByAi(params: object) {
	return request({
		url: `/api/appRole/generateByAi`,
		method: 'get',
		params
	});
}
// 获取热门角色列表
export function listHotAppRole(params: object) {
	return request({
		url: '/api/appRole/listHotAppRole',
		method: 'get',
		params
	});
}
// 获取我的角色列表
export function queryMyAppRole(params: object) {
	return request({
		url: '/api/appRole/queryMyAppRole',
		method: 'get',
		params
	});
}
export function generateAllConfigByAi(data: object,cancelToken: CancelToken) {
	return request({
		url: '/api/appRole/generateAllConfigByAi',
		method: 'post',
		data,
		cancelToken
	});
}
export function getDialoguePlugins() {
	return request({
		url: '/api/dialogue/getDialoguePlugins',
		method: 'get',
	});
}
//获取知识库
export function pageQuery(data: object) {
	return request({
		url: '/api/knowledgeBase/pageQuery',
		method: 'post',
		data
	});
}

// 更新重新生成对话选中
export function updateIsSelect(id: string) {
	return request({
		url: `/api/dialogue/updateIsSelect/${id}`,
		method: 'put',
	});
}

// 获取角色列表
export function getAppRoleListByPubic(params: object) {
	return request({
		url: '/api/appRole/getAppRoleListByPubic',
		method: 'get',
		params
	});
}


// [PC] 首页获取已经使用智能体列表[小雅第一个]
export function getAppRoleListUesdByUserId() {
	return request({
		url: `/api/appRole/getAppRoleListUesdByUserId`,
		method: 'get'
	});
}
// [PC] 移除已经使用的智能体
export function removeAppRoleUsed(id: string) {
	return request({
		url: `/api/appRole/removeAppRoleUsed/${id}`,
		method: 'delete'
	});
}
//推荐问题
export function listAiSearchQuestion(id: string) {
	return request({
		url: `/api/dialogue/listAiSearchQuestion/${id}`,
		method: 'get'
	});
}
//获取信源分类

export function searchEngineCategory() {
	return request({
		url: `/api/searchEngineCategory/allList`,
		method: 'get'
	});
}
//查询信源list
export function getSearchEngineByCategoryIds(params: object) {
	return request({
		url: `/api/searchEngine/getSearchEngineByCategoryIds`,
		method: 'get',
		params
	});
}
//取消或选择信源web
export function saveOrUpdateUserSearchEngine(data: object) {
	return request({
		url: `/api/userSearchEngine/saveOrUpdateUserSearchEngine`,
		method: 'post',
		data
	});
}
//信源 知识库查询
export function getUserKnowledgeBaseListPageQuery(data: object) {
	return request({
		url: `/api/userKnowledgeBase/getUserKnowledgeBaseListPageQuery`,
		method: 'post',
		data
	});
}
//取消或保持知识库信源
export function saveOrUpdateUserUserKnowledgeBase(data: object) {
	return request({
		url: `/api/userKnowledgeBase/saveOrUpdateUserUserKnowledgeBase`,
		method: 'post',
		data
	});
}
//获取已选择num

export function getUserSearchEngineAndUserKnowledgeBase() {
	return request({
		url: `/api/userSearchEngine/getUserSearchEngineAndUserKnowledgeBase`,
		method: 'get',
	});
}
//热点
export function getSearchEngineHotSpotNew() {
	return request({
		url: `/api/searchEngineHotSpot/getSearchEngineHotSpotNew`,
		method: 'get',
	});
}
export function preSetFileUpload(data:object) {
	return request({
		url: `/api/dialogue/preSetFileUpload`,
		method: 'post',
		data
	});
}
export function createRecord(data:object) {
	return request({
		url: `/api/shareAppRole/createRecord`,
		method: 'post',
		data
	});
}
export function getRecordsByShareId(params:object) {
	return request({
		url: `/api/shareAppRole/getRecordsByShareId`,
		method: 'get',
		params
	});
}
export function getRecords(params:object) {
	return request({
		url: `/api/shareAppRole/getRecords`,
		method: 'get',
		params
	});
}
export function removeUserAppRole(data:object) {
	return request({
		url: `/api/shareAppRole/removeUserAppRole`,
		method: 'post',
		data
	});
}
export function addUserAppRoleByShareId(params:object) {
	return request({
		url: `/api/shareAppRole/addUserAppRoleByShareId`,
		method: 'post',
		params
	});
}
export function getKnowledgeTypes() {
	return request({
		url: `/api/dialogue/getKnowledgeTypes`,
		method: 'get',
	});
}
export function saveOrUpdateUserSearchEngineType(data:object) {
	return request({
		url: `/api/userSearchEngineType/saveOrUpdateUserSearchEngineType`,
		method: 'post',
		data
	});
}
export function updateStatus(id:any) {
	return request({
		url: `/api/conversation/updateStatus/${id}`,
		method: 'put',
	});
}
export function getAppRoleIconListByRoleId() {
	return request({
		url: `/api/appRoleIcon/getAppRoleIconListByRoleId`,
		method: 'get',
	});
}
export function pageConversationsAppRole(data:object) {
	return request({
		url: `/api/conversation/pageConversationsAppRole`,
		method: 'get',
		params: data,
	});
}
export function getUserPreference() {
	return request({
		url: `/api/userPreference/getUserPreference`,
		method: 'get',
	});
}
export function saveOrUpdateUserPreference(data:object) {
	return request({
		url: `/api/userPreference/saveOrUpdateUserPreference`,
		method: 'post',
		data
	});
}
export function extract(data:object, cancelToken: CancelToken) {
	return request({
		url: `/api/dialogue/extract`,
		method: 'get',
		params: data,
		cancelToken
	});
}
export function detail(id:string|number) {
	return request({
		url: `/api/conversation/detail/${id}`,
		method: 'get',
	});
}
export function functionUsageRecord(data:object) {
	return request({
		url: `/api/functionUsageRecord/add`,
		method: 'post',
		data
	});
}
export function pageChatNotices(data:object) {
	return request({
		url: `/api/chatNotice/pageChatNotices`,
		method: 'post',
		data
	});
}
export function updateStatusByTask(data:object) {
	return request({
		url: `/api/chatNotice/updateStatus`,
		method: 'put',
		params: data,
	});
}

export function appRolePub(data:object) {
	return request({
		url: `/api/open/appRolePub/addAddAppRolePub`,
		method: 'post',
		data,
	});
}
export function getGuestUserByUniqueId() {
	return request({
		url: `/api/guest/guestUser/getGuestUserByUniqueId`,
		method: 'get',
	});
}
export function createGuestUser(data:object) {
	return request({
		url: `/api/guest/guestUser/createGuestUser`,
		method: 'post',
		data
	});
}
export function validate() {
	return request({
		url: `/api/guest/appRolePub/validate`,
		method: 'post',
	});
}
export function getLatestConversation() {
	return request({
		url: `/api/guest/conversation/getLatestConversation`,
		method: 'get',
	});
}
export function conversationGuestDetail(id:string) {
	return request({
		url: `/api/guest/conversation/detail/${id}`,
		method: 'get',
	});
}
export function guestConversationAdd(data:object) {
	return request({
		url: `/api/guest/conversation/add`,
		method: 'post',
		data
	});
}
export function getGuestRoleIdDetails(id:string) {
	return request({
		url: `/api/guest/appRole/getDetails/${id}`,
		method: 'get',
	});
}
export function listGuestDialogues(id:string) {
	return request({
		url: `/api/guest/conversation/listDialogues/${id}`,
		method: 'get',
	});
}
export function updateGuestDialogueName(id:string) {
	return request({
		url: `/api/guest/conversation/updateName/${id}`,
		method: 'put',
	});
}
export function getGuestDialogueParam(appId:string,appRoleId:string) {
	return request({
		url: `/api/guest/conversation/getDialogueParam/${appId}/${appRoleId}`,
		method: 'get',
	});
}

export function clicksGuestCount(id: string) {
	return request({
		url: `/api/guest/app/v3/clicksCount?appId=${id}`,
		method: 'get',
	});
}


export function closeGuestDialogueConn(clientId: number | string) {
	return request({
		url: '/api/guest/dialogue/closeDialogueConn/' + clientId,
		method: 'get',
	});
}
export function uploadGuestChatImg(data: object, cancelToken: CancelToken) {
	return request({
		url: '/api/guest/dialogue/uploadChatImg',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		cancelToken
	});
}

//上传文件的预解析
export function preGuestfill(data: object) {
	return request({
		url: '/api/guest/dialogue/prefill',
		method: 'post',
		data
	});
}
//CV删除图片
export function delGuestChatImg(id: string) {
	return request({
		url: '/api/guest/dialogue/delChatImg/' + id,
		method: 'delete',
	});
}

export function updateGuestStatus(id:any) {
	return request({
		url: `/api/guest/conversation/updateStatus/${id}`,
		method: 'put',
	});
}
export function preSetGuestFileUpload(data:object) {
	return request({
		url: `/api/guest/dialogue/preSetFileUpload`,
		method: 'post',
		data
	});
}
//查询智能体插件


export function getAppRoleConfByRoleId(data:object) {
	return request({
		url: `/api/appRoleUserConf/getAppRoleConfByRoleId`,
		method: 'get',
		params: data
	});
}

//更新智能体插件

export function updateAppRoleConfByRoleId(data:object) {
	return request({
		url: `/api/appRoleUserConf/updateAppRoleConfByRoleId`,
		method: 'post',
		data
	});
}





// 精选推荐列表
export function userProfileTopicsArticles(data:object) {
	return request({
		url: '/api/userProfileTopicsArticles/list',
		method: 'get',
		params: data,
	});
}
// 获取全部领域
export function categories() {
	return request({
		url: '/api/profileTopics/categories',
		method: 'get',
		
	});
}

// 论文推荐列表
export function getArticleList(data:object) {
	return request({
		url: '/api/articleRecommend/getArticleList',
		method: 'get',
		params: data,
	});
}

// 下载对话
export function downloadFile(data:object) {
	return request({
		url: `/api/dialogue/downloadFile`,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'post',
		data,
		responseType:'blob',
	});
}

// 设置兴趣
export function updateFollow(data:object) {
	return request({
		url: '/api/articleRecommend/updateFollow',
		method: 'post',
		data: data,
	});
}

// 获取推荐关注论题
export function getArticleTheme(data:object) {
	return request({
		url: '/api/articleRecommend/getArticleTheme',
		method: 'get',
		params: data,
	});
}

// 获取关注列表
export function getFollowReport(data:object) {
	return request({
		url: '/api/scienceReport/getFollowReport',
		method: 'post',
		data: data,
	});
}

// 获取订阅设置列表
export function getSubscriptionSetting(data:object) {
	return request({
		url: '/api/scienceReport/getSubscriptionSetting',
		method: 'post',
		data: data,
	});
}

// 修改新增订阅
export function saveOrUpdateSetting(data:object) {
	return request({
		url: '/api/scienceReport/saveOrUpdateSetting',
		method: 'post',
		data: data,
	});
}

// 获取相关学者列表
export function getScientistListByDialogueId(data:object, cancelToken: CancelToken) {
	return request({
		url: '/api/dialogue/getScientistListByDialogueId',
		method: 'get',
		params: data,
		cancelToken
	});
}

// 获取相关机构
export function getOrganizationListByDialogueId(data:object, cancelToken: CancelToken) {
	return request({
		url: '/api/dialogue/getOrganizationListByDialogueId',
		method: 'get',
		params: data,
		cancelToken
	});
}

// 获取推荐论题
export function getThemeListByDialogueId(data:object, cancelToken: CancelToken) {
	return request({
		url: '/api/dialogue/getThemeListByDialogueId',
		method: 'get',
		params: data,
		cancelToken
	});
}

// 获取学者列表
export function getScientList(data: object) {
  return request({
		url: '/api/lit/scientisthome/searchScientist',
		method: 'post',
		data: data,
	});
}

// 获取科研论题列表
export function getThemeList(data: object) {
  return request({
		url: '/api/lit/theme/list',
		method: 'post',
		data: data,
	});
}

export function getScientistInfo(data: object) {
  return request({
		url: '/api/lit/scientisthome/getScientistInfo',
		method: 'get',
		params: data,
	});
}

// 获取订阅列表
export function getSubscribeReport(data: object) {
  return request({
		url: '/api/scienceReport/getSubscribeReport',
		method: 'post',
		data: data,
	});
}

// 订阅任务执行
export function taskExecution(data: object) {
	return request({
		url: `/api/scienceReport/taskExecution`,
		method: 'post',
		data
	});
}

// 查询论题
export function matchThemeListByKeyword(data: object) {
	return request({
		url: `/api/lit/theme/matchThemeListByKeyword`,
		method: 'get',
		params: data,
	});
}

// 查询学者
export function matchScientistListByKeyword(data: object) {
	return request({
		url: `/api/lit/scientist/matchScientistListByKeyword`,
		method: 'get',
		params: data,
	});
}

// 获取详情
export function surveyDetail(id: string) {
	return request({
		url: `/api/lit/survey/getDetail/${id}`,
		method: 'get',
	});
}

// 综述列表
export function getSurveyList(data: object) {
	return request({
		url: `/api/lit/survey/list`,
		method: 'get',
		params: data,
	});
}

// 添加综述
export function surveyAdd(data: object) {
	return request({
		url: `/api/lit/survey/add`,
		method: 'post',
		data
	});
}

// 综述文件上传
export function surveyUploadBatch(data: object) {
	return request({
		url: '/api/lit/survey/file/uploadFile',
		method: 'post',
		data,
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	});
}

// 综述详情
export function getSurveyDetail(id: string) {
	return request({
		url: `/api/lit/survey/getDetail/${id}`,
		method: 'get',
	});
}

// 综述编辑
export function surveyEdit(data: object) {
	return request({
		url: `/api/lit/survey/edit`,
		method: 'post',
		data
	});
}

// 综述删除
export function surveydel(id: string) {
	return request({
		url: `/api/lit/survey/${id}`,
		method: 'delete',
	});
}

// 综述重新生成
export function surveyRegenerate(data: object) {
	return request({
		url: `/api/lit/survey/regenerate`,
		method: 'post',
		data,
	});
}

// 知识库
export function getknowledgeBase(data: object) {
	return request({
		url: `/api/knowledgeBase/pageQuery`,
		method: 'post',
		data,
	});
}

export function getFileAnsyTree(data: object) {
	return request({
		url: `/api/knowledgeFile/fileTree`,
		method: 'post',
		data,
	});
}

export function surveySaveKnowledge(data: object) {
	return request({
		url: `/api/lit/survey/surveySaveKnowledge`,
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		data
	});
}

export function getConversationEventsByConversationId(id: string) {
	return request({
		url: `/api/dialogue/event/getConversationEventsByConversationId/${id}`,
		method: 'get',
	});
} 

export function getUserSearchEngineType() {
		return request({
		url: `/api/userSearchEngineType/getUserSearchEngineType`,
		method: 'get',
	});
}
export function getSurveyPaperGraph(id: string) {
	return request({
	url: `/api/lit/survey/graph/getSurveyPaperGraph/${id}`,
	method: 'get',
});
}
export function articleDetail(id: string) {
	return request({
	url: `/api/lit/article/${id}`,
	method: 'get',
});
}
export function getSurveyResearchGraph(id: string) {
	return request({
	url: `/api/lit/survey/graph/getSurveyResearchGraph/${id}`,
	method: 'get',
});
}
export function getSurveyInnovateGraph(id: string) {
	return request({
	url: `/api/lit/survey/graph/getSurveyInnovateGraph/${id}`,
	method: 'get',
});
}
export function getResearchArticleListByKnowledgePoint(data:object) {
	return request({
	url: `/api/lit/survey/graph/getResearchArticleListByKnowledgePoint`,
	method: 'get',
	params:data
});
}
export function getLitSurveyEventsBySurveyId(id: string) {
	return request({
		url: `/api/lit/survey/event/getLitSurveyEventsBySurveyId/${id}`,
		method: 'get',
	});
} 
export function getResearchArticleListbyInnovationPoint(data:object) {
	return request({
		url: `/api/lit/survey/graph/getResearchArticleListbyInnovationPoint`,
		method: 'get',
		params:data
	});
} 
export function searchEngineTreeAndKbAndCustom() {
	return request({
		url: `/api/searchEngineCategory/searchEngineTreeAndKbAndCustom`,
		method: 'get'
	});
}

export function createDialogue(data: object, cancelToken?: CancelToken) {
	return request({
		url: '/api/dialogue/createDialogue',
		method: 'post',
		data,
		cancelToken,
	});
}
export function searchEngineTreeAndKbAndCustomSelectIcon() {
	return request({
		url: '/api/searchEngineCategory/searchEngineTreeAndKbAndCustomSelectIcon',
		method: 'get',
	});
}
export function getConversationEventsByConversationIdAndOffset(id: string,offset: number|string) {
	return request({
		url: `/api/dialogue/event/getConversationEventsByConversationIdAndOffset/${id}/${offset}`,
		method: 'get',
	});
} 
export function getConversationEventsByConversationIdAndLastEventId(id: string,dialogueId: string,lastEventId: number|string) {
	return request({
		url: `/api/dialogue/event/getConversationEventsByConversationIdAndLastEventId/${id}/${dialogueId}/${lastEventId}`,
		method: 'get',
	});
} 
export function getmcpLists(data:object) {
	return request({
		url: `/api/lit/mcpServer/list`,
		method: 'get',
		params:data
	});
}
export function getmcpCategoryLists() {
	return request({
		url: `/api/lit/mcpServerCategory/allList`,
		method: 'get',
	});
}

export function updateDialogueEventDetail(data: object) {
	return request({
		url: '/api/dialogue/event/updateDialogueEventDetail',
		method: 'post',
		data,
	});
}
export function getResearchArticleGraphListbyId(id: string) {
	return request({
	url: `/api/lit/survey/graph/getResearchArticleGraphListbyId?articleId=${id}`,
	method: 'get',
});
}
export function cancelConversationTask(conversationId: string) {
	return request({
		url: `/api/dialogue/event/cancelConversationTask/${conversationId}`,
		method: 'get',
	});
} 

// 获取案例列表类型
export function caseTypeInfo() {
	return request({
		url: `/api/lit/cases/getCaseTypeInfo`,
		method: 'get',
	});
} 
// 获取案例列表二级类型
export function caseDataTypeInfo() {
	return request({
		url: `/api/lit/cases/getCaseDataTypeInfo`,
		method: 'get',
	});
}

export function getCaseDetailTypeInfo() {
	return request({
		url: `/api/lit/cases/getCaseDetailTypeInfo`,
		method: 'get',
	});
}
// 获取案例列表
export function casesList(data:object) {
	return request({
		url: `/api/lit/cases/list`,
		method: 'get',
		params:data
	});
}
// 随机获取案例列表
export function casesRandom() {
	return request({
		url: `/api/lit/cases/random?size=4&caseType=system`,
		method: 'get',
		});
}
export function getUserSettings(mcpServerId: string) {
	return request({
		url: `/api/lit/userMcpServerSettings/getUserSettings/${mcpServerId}`,
		method: 'get',
	});
} 
export function saveUserSettings(data:object) {
	return request({
		url: `/api/lit/userMcpServerSettings/saveUserSettings`,
		method: 'post',
		data
	});
} 
export function getResearchArticleGraphListBySurveyId(data:object) {
	return request({
		url: `/api/lit/survey/graph/getResearchArticleGraphListBySurveyId`,
		method: 'get',
		params:data
	});
}

// 获取批注列表
export function getSurveyCommentList(data:object) {
	return request({
		url: `/api/lit/survey/comment/list`,
		method: 'get',
		params:data
	});
}

// 新增批注
export function addSurveyComment(data:object) {
	return request({
		url: `/api/lit/survey/comment`,
		method: 'post',
		data
	});
}

// 修改批注
export function editSurveyComment(data:object) {
	return request({
		url: `/api/lit/survey/comment`,
		method: 'put',
		data
	});
}


// 删除修改批注
export function delSurvey(id: string) {
	return request({
		url: `/api/lit/survey/comment/${id}`,
		method: 'delete',
	});
}

// 根据综述Id查询学术综述导读详情
export function getGuide(id: string) {
	return request({
		url: `/api/lit/survey/guide/getDetail/${id}`,
		method: 'get',
	});
}

// 综述下载
interface DownloadSurveyData {
  id: string;
  format: string;
}
export function downloadSurvey(data:DownloadSurveyData) {
	return request({
		url: `/api/lit/survey/downloadSurvey/?id=${data.id}&format=${data.format}`,
		method: 'post',
		responseType:'blob',
		data
	});
}

export function updateConversationIsView(data: object) {
	return request({
		url: `/api/conversation/updateConversationIsView/${data.id}?dialogueId=${data.dialogueId}`,
		method: 'put',
	});
}

// 更新会话名称
export function updateSurveyNameConversation(id: string) {
	return request({
		url: `/api/lit/survey/conversation/updateName/${id}`,
		method: 'put',
	});
}

// 文件转换下载
export function fileConv(data: object) {
	return request({
		url: `/api/tools-file/api/tools/fileConv`,
		method: 'get',
		params:data
	});
}

// 根据对话ID获取综述ID
export function getSurveyIdByDialogueId(id: string) {
	return request({
		url: `/api/lit/survey/getSurveyIdByDialogueId/${id}`,
		method: 'get',
	});
}
export function getOrgLists(value:string) {
	return request({
		url: '/api/org/list?keyword=' + value,
		method: 'get',
	});
}
export function bindUserOrg(data: object) {
	return request({
		url: `/api/org/saveUserOrg  `,
		method: 'post',
		data
	});
}

export function resumeFromBreakpoint(data: object) {
	return request({
		url: '/api/dialogue/event/resumeFromBreakpoint',
		method: 'post',
		data,
	});
}
export function checkResumeFromBreakpoint(data: object) {
	return request({
		url: '/api/dialogue/event/checkResumeFromBreakpoint',
		method: 'post',
		data,
	});
}
// 更新用户首次登录状态，在展示新手引导时调用
export function updateUserIsLogin() {
	return request({
		url: `${window.$website.ADMIN_URL}/api/user/updateIsLogin`,
		method: 'put',
	});
}